export const DEFAULT_STATISTICS_SECTION = 'overview';

export const STATISTICS_SECTIONS = [
  { key: 'overview' },
  { key: 'trends' },
  { key: 'breakdowns' },
  { key: 'rankings' },
];

export function buildStatisticsRoute(section = DEFAULT_STATISTICS_SECTION) {
  return `statistics/${section}`;
}

export function isStatisticsRoutePath(pathname = '') {
  return pathname === 'statistics' || pathname.startsWith('statistics/');
}

export function getStatisticsSectionFromPath(pathname = '') {
  if (!isStatisticsRoutePath(pathname)) {
    return DEFAULT_STATISTICS_SECTION;
  }

  const section = pathname.split('/')[1] || DEFAULT_STATISTICS_SECTION;

  return STATISTICS_SECTIONS.some((item) => item.key === section)
    ? section
    : DEFAULT_STATISTICS_SECTION;
}
